export default {
    namespaced: true,
    state: {
        loading: {
            form: false,
        },
        error: null,
    },
    getters: {
        errors: state => state.error
    },
    mutations: {
        SET_ERROR: (state, error) => state.error = error,
    },
    actions: {
        LOGIN_USER: ({dispatch, commit}, data) => new Promise((resolve, reject) => {
            commit('SET_LOADING', null, {root: true})
            axios.post('/api/login', data)
                .then(() => {
                    localStorage.setItem('logged', 'true')
                    commit('UNSET_LOADING', null, {root: true})
                    dispatch('profile/FETCH_USER_PROFILE', null, {root: true})
                    resolve()
                })
                .catch((err) => {
                    commit('SET_ERROR', err)
                    commit('UNSET_LOADING', null, {root: true})
                    reject()
                })
        }),
        LOGOUT_USER: ({dispatch, commit}) => new Promise((resolve, reject) => {
            commit('SET_LOADING', null, {root: true})
            axios.post('/api/logout')
                .then(() => {
                    localStorage.removeItem('logged')
                    dispatch('profile/REMOVE_USER_PROFILE', null, {root: true})
                    dispatch('cart/GET_CART', null, {root: true})
                    commit('UNSET_LOADING', null, {root: true})
                    resolve()
                })
                .catch(() => {
                    commit('UNSET_LOADING', null, {root: true})
                    reject()
                })
        }),
    }
}
